import { LitElement, css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';
import { ProductSearchResult, ProductsQuery } from '../api/models';
import { switchLayout } from '../media-query';
import { Layout } from '../state/pages';
import '../components/product-searchresult';

@customElement('product-searchresults')
export class ProductSearchresultsComponent extends LitElement {

  static styles = [
    css`
    sl-tab-group {
      background: white;
    }
    .grid-container {
      display: grid;
      width: 100%;
      box-sizing: border-box; 
      align-content: start;
      grid-template-rows: auto; 
      grid-template-columns: repeat(1, 1fr);       
    }
    .grid-container.phone {
      gap: var(--sl-spacing-2x-small);
      padding: var(--sl-spacing-2x-small);
    }
    .grid-container.tablet {
      gap: var(--sl-spacing-x-small);
      padding: var(--sl-spacing-x-small);
      grid-template-columns: repeat(2, 1fr);       
    }
    .grid-container.laptop {
      gap: var(--sl-spacing-small);
      padding: var(--sl-spacing-small);
      grid-template-columns: repeat(3, 1fr);       
    }
    .grid-container.desktop {
      gap: var(--sl-spacing-medium);
      padding: var(--sl-spacing-medium);
      grid-template-columns: repeat(5, 1fr);       
    }`    
  ];

  @property({ attribute: false, state: false, type: Number })
  public layout: Layout = Layout.PHONE;


  @property({ attribute: false, state: false, type: Object })
  public productsSearchResponse: ProductsQuery | null = null;

  @property({ attribute: false, state: false, type: Array })
  public productsFavorites: boolean[] = [] as boolean[];

  @property({ attribute: true, state: false, type: String })
  caption: string = "productten";

  render() {
    if (!this.productsSearchResponse?.data?.results
      || !this.productsSearchResponse?.data?.results.length) {
      return nothing;
    }
    return html`
        <sl-tab-group>
          <sl-tab slot="nav" panel="product-search-results">${this.caption}</sl-tab>
          <sl-tab-panel name="product-search-results">
          <div class=${switchLayout(this.layout, "grid-container phone", "grid-container tablet", "grid-container laptop", "grid-container desktop")}>
          ${repeat((this.productsSearchResponse?.data?.results || []), (productSearchResult: ProductSearchResult, index: number) => html`
          <product-searchresult .productSearchResult=${productSearchResult} ?favorite=${this.productsFavorites[index]} .layout=${this.layout}></product-searchresult>
          `)}
          </div>
          </sl-tab-panel>
        </sl-tab-group>
    `;
  }

}
